import React, { FC } from 'react'

interface Props {
  size?: number
  className?: string
}

export function FacebookIcon({ size = 25, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 28 28"
      fill="none"
      className={className}
    >
      <g>
        <path
          d="M23.998 12C23.998 5.372 18.626 0 11.999 0C5.372 0 0 5.372 0 12C0 17.988 4.388 22.952 10.124 23.852V15.468H7.078V11.999H10.124V9.356C10.124 6.348 11.916 4.687 14.656 4.687C15.969 4.687 17.342 4.921 17.342 4.921V7.874H15.83C14.34 7.874 13.875 8.799 13.875 9.748V12H17.203L16.671 15.469H13.875V23.853C19.611 22.953 23.999 17.989 23.999 12H23.998Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
export default FacebookIcon
